import { render, staticRenderFns } from "./SendInvoices.vue?vue&type=template&id=5853ce7a&scoped=true"
import script from "./SendInvoices.vue?vue&type=script&lang=js"
export * from "./SendInvoices.vue?vue&type=script&lang=js"
import style0 from "./SendInvoices.vue?vue&type=style&index=0&id=5853ce7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5853ce7a",
  null
  
)

export default component.exports